import domify from 'domify';
import splash from 'website-404-error-page/build/website-404-error-page.pug';
import container from 'modules/section-content';
import metadata from './metadata.json';

export default function renderNotfound(ctx, next) {
  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);
  next();
}



// WEBPACK FOOTER //
// ./src/pages/notfound/renderNotfound.js